// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2bT5I","card-content":"_2gvHj"};